const ChatPrefillMessages = {
  asap: 'I’m interested in a flight, but the flight is too soon to see instant pricing.',
  international: 'I’m interested in an international flight.',
  'passenger-count': 'I’m interested in a flight for more than 14 passengers.',
  'no-results': 'I’m interested in a flight, but no results were available.',
  'too-many-segments': 'I’m interested in a flight with multiple segments.'
};

export default ChatPrefillMessages;
